module.exports = __webpack_public_path__ + "img/saveLocal.ffb7c227.png";